import { Box } from "native-base";
import {
  VictoryAxis,
  VictoryChart,
  VictoryContainer,
  VictoryLabel,
  VictoryLine,
  VictoryScatter,
} from "victory-native";
import * as React from "react";
import { useWindowDimensions } from "react-native";
import Colors from "../../const/Colors";
import { API } from "../../api/types";
import { isEmpty } from "lodash";

const ResultChart = ({ data }: { data: API.ResultChart[] | null }) => {
  //=========== HOOK ==========
  const { width } = useWindowDimensions();

  // data = [
  //   { x: 2, y: 0 },
  //   { x: 3, y: 0 },
  //   { x: 4, y: 0 },
  //   { x: 5, y: 0 },
  //   { x: 6, y: 0 },
  //   { x: 7, y: 0 },
  // ];
  // data = null;

  //=========== RANGE ==========
  let DEFAULT_Y_MAX = 100;

  // let isNoData = true;
  // if (data != null && !isEmpty(data)) {
  //   isNoData = data.every((value) => value.y == 0 || value.y == undefined);
  // }
  //
  // let yMax;
  // if (isNoData) {
  //   yMax = DEFAULT_Y_MAX;
  // } else {
  //   yMax = Math.max(...data!!.map((value) => value.y ?? 0));
  //
  //   yMax += 0.25 * yMax;
  // }

  // ppw("ResultChart().yMax", yMax);
  // ppw("ResultChart().data", data);

  //=========== OUT ==========
  return (
    <Box
      height={200}
      // backgroundColor={'red.200'}
    >
      <VictoryChart
        height={200}
        width={width}
        domain={{ x: [1, 7], y: [0, DEFAULT_Y_MAX] }}
        padding={{ top: 24, bottom: 12, right: 1, left: 1 }}
        domainPadding={{ x: 20 }}
        containerComponent={
          <VictoryContainer
            style={{
              pointerEvents: "auto",
              userSelect: "auto",
              touchAction: "auto",
            }}
          />
        }
      >
        {/* h line */}
        <VictoryAxis
          style={{
            axis: { stroke: Colors.transparent },
            grid: {
              stroke: Colors.chartLine,
            },
            tickLabels: {
              fontSize: 0,
            },
          }}
          dependentAxis={true}
          crossAxis={true}
          tickValues={[0, 20, 40, 60, 80, 100]}
          tickLabelComponent={
            <VictoryLabel verticalAnchor="end" textAnchor="middle" dx={30} />
          }
        />
        {/*<VictoryAxis*/}
        {/*  style={{*/}
        {/*    axis: { stroke: Colors.transparent },*/}
        {/*    grid: {*/}
        {/*      stroke: Colors.chartLine,*/}
        {/*    },*/}
        {/*    tickLabels: {*/}
        {/*      fontSize: 0,*/}
        {/*    },*/}
        {/*  }}*/}
        {/*  dependentAxis={true}*/}
        {/*  crossAxis={true}*/}
        {/*  tickValues={[0]}*/}
        {/*  tickLabelComponent={*/}
        {/*    <VictoryLabel verticalAnchor="end" textAnchor="middle" dx={30} />*/}
        {/*  }*/}
        {/*/>*/}

        <VictoryScatter
          style={{ data: { fill: Colors.ammChartDot } }}
          size={8}
          data={data ?? []}
        />

        <VictoryLine
          style={{
            data: {
              stroke: Colors.ammChartDot,
              strokeWidth: 3,
            },
          }}
          data={data ?? []}
        />

        {/* text on h line */}
        <VictoryAxis
          style={{
            axis: { stroke: null },
            grid: {
              stroke: null,
            },
            tickLabels: {
              fontSize: 12,
            },
          }}
          dependentAxis={true}
          crossAxis={true}
          tickValues={[0, 20, 40, 60, 80, 100]}
          tickLabelComponent={
            <VictoryLabel verticalAnchor="end" textAnchor="middle" dx={30} />
          }
        />

        {/*<VictoryAxis*/}
        {/*  style={{*/}
        {/*    axis: { stroke: Colors.transparent },*/}
        {/*    grid: {*/}
        {/*      stroke: Colors.transparent,*/}
        {/*    },*/}
        {/*    tickLabels: {*/}
        {/*      fontSize: 12,*/}
        {/*    },*/}
        {/*  }}*/}
        {/*  dependentAxis={true}*/}
        {/*  crossAxis={true}*/}
        {/*  tickValues={[0]}*/}
        {/*  tickLabelComponent={*/}
        {/*    <VictoryLabel verticalAnchor="end" textAnchor="middle" dx={30} />*/}
        {/*  }*/}
        {/*/>*/}
      </VictoryChart>
    </Box>
  );
};

export default ResultChart;
